import React, { useContext, useEffect, useState } from 'react';
import { useForm, Controller, useFormContext } from 'react-hook-form';
import { TextField, Button, Grid, Box, Chip, Stack, Divider, Autocomplete, FormControl, Select, MenuItem, Typography, Card, FormControlLabel, Checkbox, CardContent, ListItemText } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { CalendarIcon, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BookingService } from '../../Booking/Service';
import pdfLogo from '../../../assets/images/pdf-icon-4.png'
import ImageAsBase64 from '../../../utils/imageToBase64';
import CudelLogo from '../../../assets/images/cudel_logo.png'
import AuthorizedSignature from '../../../assets/images/dummy_signature.png';
import { UserProfileContext } from '../UserProfile';
import MyDocument from '../../../components/PdfGenerator/MyDocument';
import { pdf } from '@react-pdf/renderer';
import { numberToWords } from '../../../utils/numberToWords';
import stateList from '../../../utils/stateList.json';
import GeneratePdf from '../viewProfile/paymentDetails/GeneratePdf';


const formatValue = (value) => {
  if (!value) return '';  // Return empty string instead of 0
  const numValue = parseFloat(value);
  return isNaN(numValue) ? '' : numValue.toString();
}

const RegistrationFeeInfo = ({ registrationFee }) => {
  const { providerPersonalDetails, businessDetailsData } = useContext(UserProfileContext);
  const { control, handleSubmit, setValue, formState: { errors }, watch } = useFormContext();
  const taxSlab = watch('taxSlab');
  const totalAmount = watch('totalAmount');
  const discount = watch('discountPercent');
  const calculate = () => {
    //initialize 
    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    let discountRate = discount || 0;
    let discountAmount = 0;
    let baseAmount = 0;
    let paidAmount = totalAmount || 0;
    let taxableAmount = 0;
    let gstAmount = 0;

    // Remove GST from total amount
    taxableAmount = totalAmount / (1 + 18 / 100);
    // Calculate GST amount
    gstAmount = totalAmount - taxableAmount;

    // Calculate base amount before discount
    baseAmount = taxableAmount / (1 - discountRate / 100);
    // Calculate discount amount
    discountAmount = baseAmount - taxableAmount;

    if (taxSlab === 'igst') {
      igst = gstAmount
    } else if (taxSlab === 'gst') {
      sgst = cgst = gstAmount / 2;
    }
    setValue('sgst', sgst, { shouldValidate: true });
    setValue('cgst', cgst, { shouldValidate: true });
    setValue('igst', igst, { shouldValidate: true });
    setValue('baseAmount', baseAmount, { shouldValidate: true });
    setValue('taxableAmount', taxableAmount, { shouldValidate: true });
    setValue('gstAmount', gstAmount, { shouldValidate: true });
    setValue('discount', discountAmount, { shouldValidate: true });
  }
  useEffect(() => {
    if (totalAmount) {
      calculate();
    }
  }, [totalAmount, taxSlab, discount]);

  /************  Bill Pdf Related  ******************/

  const [logoData, setLogoData] = useState(null);
  const [signatureData, setSignatureData] = useState(null);
  const [invoiceData, setInvoiceData] = useState();

  const trimAddress = (address) => {
    const parts = address.split(",");
    if (parts.length >= 3) {
      return parts.slice(0, 2).join(",").trim();
    }
    return address.trim();
  };

  // Load logo on component mount
  useEffect(() => {
    const loadLogo = async (image) => {
      try {
        if (image == "logo") {
          const base64 = await ImageAsBase64(CudelLogo);
          setLogoData(base64);
        } else if (image == "signature") {
          const base64 = await ImageAsBase64(AuthorizedSignature);
          setSignatureData(base64);
        }
      } catch (error) {
        console.error("Error loading logo:", error);
      }
    };

    loadLogo("logo");
    loadLogo("signature");
    console.log("registrationFee:", registrationFee);
    if (registrationFee && registrationFee?.txnId) {
      console.log("registrationFee:", registrationFee);

      //   // setRegistrationFee(registrationFee);
      setInvoiceData((pre) => ({
        ...pre,
        //     // Company Information
        company: {
          name: "Cudel Delight Solutions Pvt. Ltd.",
          address: "B-154, Sector-63, Noida, Gautambuddha Nagar,",
          state: "Uttar Pradesh",
          pincode: "201301",
          gstin: "09AAHCC0707E1ZP",
          stateCode: "09",
        },
        //     // Invoice Details
        invoice: {
          number: `CD/${registrationFee.txnId}/UP/${dayjs(
            registrationFee.txnDate
          ).format("YY")}`,
          date: dayjs(registrationFee.txnDate).format("DD-MMM-YY"),
          reference: registrationFee.txnId,
          mode: registrationFee.paymentMethod,
        },
        // Buyer Information
        buyer: {
          name:
            providerPersonalDetails?.firstName ||
            "" + "" + providerPersonalDetails?.middleName ||
            "" + "" + providerPersonalDetails?.lastName ||
            "",
          address:
            trimAddress(providerPersonalDetails?.serviceAddress?.address) || "",
          state: providerPersonalDetails?.serviceAddress?.state || "",
          pincode: providerPersonalDetails?.serviceAddress?.pincode || "",
          panIt: businessDetailsData?.panNumber || "",
          gstin: businessDetailsData?.gstNumber || "",
          placeOfSupply: providerPersonalDetails?.serviceAddress?.state || "",
          stateCode:
            stateList.find(
              (state) => state.name == providerPersonalDetails?.serviceAddress?.state
            )?.code || "",
          buyerOrderNo: "PO123456",
          termsOfDelivery: "Immediate",
        },
        // Items/Services
        items: [
          {
            description: "Registration Fees",
            hsnSac: "996331",
            rate: registrationFee.baseAmount,
            quantity: 1,
            amount: registrationFee.totalAmount,
            cgstRate: providerPersonalDetails?.serviceAddress?.state == "Uttar Pradesh" ? 9 : 0,
            sgstRate: providerPersonalDetails?.serviceAddress?.state == "Uttar Pradesh" ? 9 : 0,
            igstRate: providerPersonalDetails?.serviceAddress?.state == "Uttar Pradesh" ? 0 : 18,
            discount: registrationFee?.discountPercent || 0,
          },
        ],
        // Totals
        totals: {
          subTotal: registrationFee.baseAmount,
          cgstTotal: registrationFee.cgst,
          sgstTotal: registrationFee.sgst,
          igstTotal: registrationFee.igst,
          grandTotal: registrationFee.totalAmount,
          amountInWords: numberToWords(registrationFee.totalAmount),
        },
        // Tax Details
        taxBreakup: [
          {
            type:
              invoiceData?.company?.state == invoiceData?.buyer?.state
                ? "Intra State"
                : "Inter State",
            rate: 18,
            taxableValue: registrationFee.baseAmount,
            cgstAmount: registrationFee.cgst,
            sgstAmount: registrationFee.sgst,
            igstAmount: registrationFee.igst,
          },
        ],
        // Additional Details
        additional: {
          remarks: `Reference: ${registrationFee.txnId}, DATE-${dayjs(
            registrationFee.txnDate
          ).format("DD-MM-YYYY")}`,
          bankDetails: {
            bankName: "HDFC Bank",
            accountNo: "XXXXXXXXXXXX1234",
            ifscCode: "HDFC0001234",
            branch: "Noida Sector 63",
          },
          termsAndConditions: [
            "1. Payment should be made within 30 days",
            "2. Goods once sold cannot be returned",
            "3. Interest at 18% p.a. will be charged on delayed payments",
          ],
        },
      }));
    }
  }, [registrationFee]);
  const [totals, setTotals] = useState({
    totalQuantity: 0,
    totalItems: 0,
    subTotal: 0,
    totalSGST: 0,
    totalCGST: 0,
    totalIGST: 0,
    totalTax: 0,
    grandTotal: 0
  });
  const [taxBreakup, setTaxBreakup] = useState({
    slab5: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
    slab12: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
    slab18: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
    slab28: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 }
  });
  const calculateTotals = (items) => {
    const newTaxBreakup = {
      slab5: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
      slab12: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
      slab18: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 },
      slab28: { baseAmount: 0, discount: 0, sgst: 0, cgst: 0, igst: 0, total: 0 }
    };

    let totalQty = 0;
    let subTotal = 0;
    let totalDiscount = 0;
    let totalSGST = 0;
    let totalCGST = 0;
    let totalIGST = 0;

    items.forEach(item => {
      const totalTaxRate = (item.sgstRate + item.cgstRate + item.igstRate);
      // Handle discount calculation safely
      const discountAmount = item.discount ? (item.rate * item.discount) / 100 : 0;
      const effectiveRate = item.rate - discountAmount;
      const taxedAmount = effectiveRate * (totalTaxRate / 100);
      const taxableAmount = effectiveRate * item.quantity;
      const amount = (effectiveRate + taxedAmount) * item.quantity;
      const totalDiscountAmount = discountAmount * item.quantity;

      totalQty += item.quantity;
      subTotal += item.rate * item.quantity;

      // Determine which slab the item belongs to based on total tax rate
      const slabKey = `slab${totalTaxRate}`;

      if (newTaxBreakup[slabKey]) {
        newTaxBreakup[slabKey].baseAmount += item.rate * item.quantity;
        newTaxBreakup[slabKey].discount += totalDiscountAmount;
        newTaxBreakup[slabKey].sgst += taxableAmount * (item.sgstRate / 100);
        newTaxBreakup[slabKey].cgst += taxableAmount * (item.cgstRate / 100);
        newTaxBreakup[slabKey].igst += taxableAmount * (item.igstRate / 100);
        newTaxBreakup[slabKey].total += (
          newTaxBreakup[slabKey].sgst +
          newTaxBreakup[slabKey].cgst +
          newTaxBreakup[slabKey].igst
        );
      }

      totalDiscount += totalDiscountAmount;
      totalCGST += taxableAmount * (item.cgstRate / 100);
      totalSGST += taxableAmount * (item.sgstRate / 100);
      totalIGST += taxableAmount * (item.igstRate / 100);
    });

    const totalTax = totalSGST + totalCGST + totalIGST;
    const grandTotal = subTotal + totalTax - totalDiscount;

    setTaxBreakup(newTaxBreakup);
    setTotals({
      totalQuantity: totalQty,
      totalItems: items.length,
      subTotal: subTotal,
      totalSGST: totalSGST,
      totalCGST: totalCGST,
      totalIGST: totalIGST,
      totalTax: totalTax,
      grandTotal: grandTotal,
      totalDiscount: totalDiscount
    });
  };
  useEffect(() => {
    if (invoiceData && invoiceData?.items?.length > 0) {
      calculateTotals(invoiceData.items);
    }
  }, [invoiceData]);

  const handleOpenInNewTab = async () => {
    const blob = await pdf(
      <MyDocument
        data={invoiceData}
        logoData={logoData}
        signatureData={signatureData}
      />
    ).toBlob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  };
  return (
    <Grid item xs={12} lg={7}>
      <Card sx={{}}>
        <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
          <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Registration Fee Info</Typography>
        </Box>
        <Grid container spacing={1} sx={{ p: '1%' }}>

          {/* <Grid item xs={12} sm={6} md={3} order={{ xs: 2, md: 1 }} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payment Category</Typography>
            <Controller
              name='paymentType'
              control={control}
              defaultValue={[]}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  fullWidth
                  {...field}
                  disabled
                  size='small'
                  // error={!!error}
                  type='number'
                  placeholder='Registration Fee'

                  // Add these props to prevent increment/decrement
                  inputProps={{
                    style: { fontSize: '0.65rem' },
                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                    onKeyDown: (e) => {
                      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                        e.preventDefault();
                      }
                    }
                  }}
                />
              )}
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6} md={3} order={{ xs: 3, md: 2 }} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Transaction Type</Typography>
            <TextField
              // {...field}
              disabled
              fullWidth
              size='small'
              // error={!!error}
              type='number'
              placeholder='Credit'

              // Add these props to prevent increment/decrement
              inputProps={{
                style: { fontSize: '0.65rem' },
                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                onKeyDown: (e) => {
                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    e.preventDefault();
                  }
                }
              }}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={9} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payment Status</Typography>
                <Chip
                  label={watch('status') || 'PENDING'}
                  size='small'
                  color={watch('status') === 'COMPLETED' ? 'success' : 'warning'}
                  sx={{ fontSize: '.75rem' }}
                />
              </Grid>

              <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                {watch('status') == 'COMPLETED' &&
                  // <Box sx={{cursor:'pointer',width:'fit-content'}} onClick={()=>handleOpenInNewTab()}>
                  //   <img
                  //     src={pdfLogo}
                  //     alt='download_pdf_logo'
                  //     style={{width:'50px',height:'50px'}}
                  //   />
                  // </Box>
                  <GeneratePdf invoiceData={invoiceData} taxBreakup={taxBreakup} totals={totals} />
                }
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payment Method <span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='paymentMethod'
              control={control}
              rules={{ required: 'select gender' }}
              render={({ field, fieldState: { error } }) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    size='small'
                    sx={{
                      minHeight: '0px',
                      // height: '1.6rem',
                      fontSize: '0.75rem',
                      // fontWeight: '600',
                      textTransform: 'capitalize'
                    }}
                    error={!!error}
                  // helperText={error && error?.message}
                  >
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='CASH'>CASH</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='CARD'>CARD</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='WALLET'>WALLET</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='ONLINE'>ONLINE</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='NEFT'>NEFT</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='UPI'>UPI</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} sx={{}}>
            <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Transaction Date<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name="txnDate"
              control={control}
              // defaultValue={dayjs().subtract(18, 'year').format('YYYY-MM-DD')}
              rules={{
                required: "Transaction Date is required",
                validate: (value) => {
                  if (!value) return "Transaction Date is required";
                  const date = dayjs(value);
                  const today = dayjs().startOf('day');

                  if (!date.isValid()) return "Invalid Transaction Date";
                  if (date.isAfter(today)) return "Transaction Date must be today or before";
                  return true;
                }
              }}
              render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    {...restField}
                    sx={{
                      '& . iconButton': {
                        padding: 0.5,
                        fontSize: '1rem'
                      }
                    }}
                    value={value ? dayjs(value) : null}
                    onChange={(newValue) => {
                      // Store the date in YYYY-MM-DD format for database compatibility
                      onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                    }}
                    format="DD-MM-YYYY" // Display format for user
                    maxDate={dayjs().startOf('day')}
                    slots={{
                      openPickerIcon: (props) => (
                        <CalendarIcon
                          {...props}
                          sx={{
                            fontSize: '1rem', // Control icon size
                            color: 'gray',    // Optional: control icon color
                            padding: 0
                          }}
                        />
                      ),
                    }}
                    slotProps={{
                      textField: {
                        error: !!error,
                        // helperText: error?.message,
                        fullWidth: true,
                        // required: true,
                        size: 'small',
                        inputProps: {
                          style: { fontSize: '.75rem' }
                        }
                      }
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Transaction Id<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='txnId'
              control={control}
              rules={{
                required: "required",
                pattern: {
                  value: /^[a-z0-9]*$/,
                  message: "only alphanumeric allowed"
                }
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  sx={{}}
                  fullWidth
                  size='small'
                  InputProps={{
                    style: {
                      // height:'2rem',
                      fontSize: '.75rem'
                    },
                    // inputProps:{
                    //     style:{textTransform:"uppercase"},
                    // }   
                  }}
                  error={!!error}
                // helperText={error && error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Tax Category <span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='taxSlab'
              control={control}
              rules={{ required: 'select Tax Category' }}
              render={({ field, fieldState: { error } }) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    size='small'
                    sx={{
                      minHeight: '0px',
                      // height: '1.6rem',
                      fontSize: '0.75rem',
                      // fontWeight: '600',
                      textTransform: 'capitalize'
                    }}
                    error={!!error}
                  // helperText={error && error?.message}
                  >
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='igst'>IGST_18%</MenuItem>
                    <MenuItem sx={{ fontSize: '0.75rem' }} value='gst'>GST_18%</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>SGST<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='sgst'
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  sx={{}}
                  value={parseFloat(field.value).toFixed(2)}
                  disabled
                  fullWidth
                  size='small'
                  InputProps={{
                    style: {
                      fontSize: '.75rem'
                    },
                  }}
                  error={!!error}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>CGST<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='cgst'
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  sx={{}}
                  value={parseFloat(field.value).toFixed(2)}
                  disabled
                  fullWidth
                  size='small'
                  InputProps={{
                    style: {
                      fontSize: '.75rem'
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>IGST<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='igst'
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  sx={{}}
                  value={parseFloat(field.value).toFixed(2)}
                  disabled
                  fullWidth
                  size='small'
                  InputProps={{
                    style: {
                      fontSize: '.75rem'
                    },
                  }}
                />
              )}
            />
          </Grid>
          {/* discount section */}
          {/* <Grid item xs={12} sm={6} md={3} sx={{}}>
              <Typography sx={{fontWeight:'600', display:'flex ',alignItems:'center',fontSize:'.75rem'}}>{`Discount(%)`}</Typography>
              <Controller
                name='discountPercent'
                control={control}
                // rules={{
                //   required:'enter Paid Amount',
                //   validate: (value) => {
                //     const numValue = parseInt(value, 10);                  
                //     if (isNaN(numValue)) return 'Please enter a valid Amount';
                //     if (numValue <= 0) return 'Paid Amount should be greater than 0';
                //     // if (numValue > 9999) return 'Waive Visit Charge cannot exceed Rs. 9999';
                //     return true;                    
                //   }
                // }}
                defaultValue={[]}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled
                    size='small'
                    error={!!error}
                    type='number'
                    placeholder='0'

                    // Add these props to prevent increment/decrement
                    inputProps={{
                      style: { fontSize: '0.65rem' },
                      onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                      onKeyDown: (e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                          }
                      }
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                        // field.onChange(formatValue(inputValue));
                        let finalValue = formatValue(inputValue);
                    
                        // Check if the value exceeds 10000 and constrain it
                        const numValue = parseFloat(finalValue);
                        // if (!isNaN(numValue) && numValue > 9999) {
                        //     finalValue = '9999';
                        // }
                        
                        field.onChange(finalValue);
                      }
                    }}
                  />
                )}
              />
            </Grid> */}
          <Grid item xs={12} sm={6} md={3} order={{ xs: 12 }} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Amount Paid <span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              name='totalAmount'
              control={control}
              rules={{
                required: 'enter Paid Amount',
                validate: (value) => {
                  const numValue = parseInt(value, 10);
                  if (isNaN(numValue)) return 'Please enter a valid Amount';
                  if (numValue <= 0) return 'Paid Amount should be greater than 0';
                  // if (numValue > 9999) return 'Waive Visit Charge cannot exceed Rs. 9999';
                  return true;
                }
              }}
              defaultValue={[]}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  fullWidth
                  size='small'
                  error={!!error}
                  type='number'
                  placeholder='0'

                  // Add these props to prevent increment/decrement
                  inputProps={{
                    style: { fontSize: '0.65rem' },
                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                    onKeyDown: (e) => {
                      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                        e.preventDefault();
                      }
                    }
                  }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                      // field.onChange(formatValue(inputValue));
                      let finalValue = formatValue(inputValue);

                      // Check if the value exceeds 10000 and constrain it
                      const numValue = parseFloat(finalValue);
                      // if (!isNaN(numValue) && numValue > 9999) {
                      //     finalValue = '9999';
                      // }

                      field.onChange(finalValue);
                    }
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} order={{ xs: 13 }} sx={{}}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Comment<span style={{ color: '#d32f2f' }}>*</span></Typography>
            <Controller
              control={control}
              name="comment"
              rules={{
                required: 'Enter comment',
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  // label="Enter Service Description"
                  variant="outlined"
                  size="small"
                  inputProps={{ style: { fontSize: '0.65rem' } }}
                  fullWidth
                  error={!!error}
                // multiline
                // rows={1}
                // maxRows={4}
                />
              )}
            />
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

export default RegistrationFeeInfo;
